import { render, staticRenderFns } from "./ItemFilterAuctionFilter.vue?vue&type=template&id=653704ee&scoped=true"
import script from "./ItemFilterAuctionFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterAuctionFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653704ee",
  null
  
)

export default component.exports